import { useLocation, useNavigate } from 'react-router-dom';

const useActiveTab = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab from URL
  const params = new URLSearchParams(location.search);
  const activeTab = params.get('tab') === 'chat' ? 1 : 0;

  const setActiveTab = (tab: number) => {
    const newParams = new URLSearchParams(location.search);
    if (tab === 0) {
      newParams.delete('tab');
    } else if (tab === 1) {
      newParams.set('tab', 'chat');
    }
    const newSearch = newParams.toString();
    const newUrl = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname;
    navigate(newUrl, { replace: true });
  };

  return {
    activeTab,
    setActiveTab,
  };
};

export default useActiveTab;
